import gql from "graphql-tag";
import getQuery from "../utils/get_query";
import { GetParcisionWalletType } from "./constants";

export default async function getParcisionWallet(sub: string) {
  // create Parcision wallet if it does not exist, otherwise get existing Parcision wallet
  const variables = {
    sub,
  };

  const query = gql`
    query {
      getParcisionWallet {
        #credentials {
        #  AccessKeyId
        #  Expiration
        #  SecretKey
        #  SessionToken
        #  RefreshToken
        #}
        address
      }
    }
  `;

  const data = await getQuery<GetParcisionWalletType>(query, variables);
  return data.getParcisionWallet;
}
